import * as React from "react";
import styled from "@emotion/styled";
import Modal from "@/components/molecules/Modal";
import MediaQueryContext, { initMediaQueryStore } from "@/contexts/MediaQuery";
import { useTheme } from "@/hooks/useTheme";
import roadDimensionIcon from "@/assets/icons/width-height-info.svg";
import Button from "@/components/atoms/Button";
import breakpoint from "@/utils/breakpoint";

type RoadConnectingInfoProps = Record<string, any> & React.HTMLAttributes<HTMLDivElement>;

const ModalBody = styled(Modal.Body)`
  border: none;
  overflow: hidden;
  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-track {
    background: #ffffff;
  }
  ::-webkit-scrollbar-thumb {
    background: #cccccc;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

const BodyWrapper = styled.div``;

const StyledBodyIcon = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const StyledText = styled.div`
  padding-top: 40px;
  padding-left: 60px;
  padding-bottom: 23px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  ${breakpoint.lessThan("sm")`
  padding-left: 0;
  padding-top: 10px;
  padding-bottom: 10px;
`}
`;

const ModalFooter = styled(Modal.Footer)`
  text-align: center;
`;

const CloseCenterButton = styled(Button)`
  width: 170px;
  height: 44px;
  background: #ffffff;
  border: 1px solid #333333;
  border-radius: 24px;
  opacity: 1;
  font-size: 14px;
  font-weight: 700;
  color: #333333;
  margin-bottom: 20px;
  ${breakpoint.lessThan("sm")`
  margin: 0;
  margin: 20px 0 0;
    padding: 5 10px;
  `}
`;

const RoadConnectingInfo = ({ open, onCloseClick }: RoadConnectingInfoProps) => {
  const { isNewTheme } = useTheme();
  const { current: range } = React.useContext(MediaQueryContext) || initMediaQueryStore("md");

  const cssOverrideModalStyle = () => {
    const cssOverrideModalStyle = {
      overflow: "hidden",
      padding: "10px 10px",
      borderRadius: "10px",
      margin: "0",
    };
    if (isNewTheme) {
      if (range === "sm") {
        cssOverrideModalStyle.padding = "10px 20px 20px 20px";
        cssOverrideModalStyle.margin = "60px 15px 0 15px";
      }
    }

    return cssOverrideModalStyle;
  };

  const handleClose = () => {
    onCloseClick();
  };

  return (
    <>
      {open && (
        <Modal
          top={range === "sm" ? "0%" : "12%"}
          open={open}
          width={range === "sm" ? "345px" : "680px"}
          height={range === "sm" ? "334px" : "540px"}
          style={cssOverrideModalStyle()}
          flex
        >
          <ModalBody>
            <BodyWrapper>
              <StyledText>道路の情報を入力してください。</StyledText>
              <StyledBodyIcon
                src={roadDimensionIcon}
                width={range === "sm" ? "300px" : "500px"}
                height={range === "sm" ? "200px" : "333px"}
              />
            </BodyWrapper>
          </ModalBody>
          <ModalFooter>
            <CloseCenterButton onClick={handleClose} color="danger">
              閉じる
            </CloseCenterButton>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};

export default RoadConnectingInfo;
